export default "__VITE_ASSET__D7NANM8Z__"